import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


// Home Pages
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';

// Auth & Error
import { LoginRegisterComponent } from './components/pages/login-register/login-register.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { AdminloginComponent } from './components/pages/adminlogin/adminlogin.component';
// import { AuthGuard } from './components/auth/authguard ';

// Static Pages
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { TermsConditionComponent } from './components/pages/terms-condition/terms-condition.component';

// Product Pages
import { MedeilposComponent } from './components/pages/medeilpos/medeilpos.component';
import { MedeilhqComponent } from './components/pages/medeilhq/medeilhq.component';
import { HosbayComponent } from './components/pages/hosbay/hosbay.component';
import { MedeilstandaloneComponent } from './components/pages/medeilstandalone/medeilstandalone.component';
import { AllotmedComponent } from './components/pages/allotmed/allotmed.component';
import { ProductloginComponent } from './components/pages/productlogin/productlogin.component';

// Pricing Pages
import { AllotmedpricingComponent } from './components/pages/productpricing/allotmedpricing/allotmedpricing.component';
import { MedeilhqpricingComponent } from './components/pages/productpricing/medeilhqpricing/medeilhqpricing.component';
import { MedeilpospricingComponent } from './components/pages/productpricing/medeilpospricing/medeilpospricing.component';
import { MedeilpricingComponent } from './components/pages/productpricing/medeilpricing/medeilpricing.component';

// Industry Verticals
import { GeneralagroComponent } from './components/pages/verticals/generalagro/generalagro.component';
import { GeneralcosmeticsComponent } from './components/pages/verticals/generalcosmetics/generalcosmetics.component';
import { GeneralhealthcareComponent } from './components/pages/verticals/generalhealthcare/generalhealthcare.component';
import { GeneralopticalsComponent } from './components/pages/verticals/generalopticals/generalopticals.component';
import { GeneralpharmacyComponent } from './components/pages/verticals/generalpharmacy/generalpharmacy.component';
import { GeneralveterinaryComponent } from './components/pages/verticals/generalveterinary/generalveterinary.component';
import { SurgicaldeviceComponent } from './components/pages/verticals/surgicaldevice/surgicaldevice.component';
import { MedeicaldeviceComponent } from './components/pages/verticals/medeicaldevice/medeicaldevice.component';

// Blog & Media
import { MedeildownloadComponent } from './components/pages/medeildownload/medeildownload.component';
import { ViewblogComponent } from './components/pages/viewblog/viewblog.component';
import { BlogDetailComponent } from './components/pages/blog-detail/blog-detail.component';
import { MedeilBlogsComponent } from './components/pages/medeil-blogs/medeil-blogs.component';
import { ViewVideosComponent } from './components/pages/view-videos/view-videos.component';
import { AddVideosComponent } from './components/pages/add-videos/add-videos.component';
import { VideoDetailsComponent } from './components/pages/video-details/video-details.component';
import { ProductVideoComponent } from './components/pages/product-video/product-video.component';

// Demo & Templates
import { PosenquiryComponent } from './components/landingpages/posenquiry/posenquiry.component';
import { PosdemorequestComponent } from './components/landingpages/posdemorequest/posdemorequest.component';
import { TemplateOneComponent } from './components/landingpage-templates/template-one/template-one.component';
import { TemplateTwoComponent } from './components/landingpage-templates/template-two/template-two.component';
import { TemplateListComponent } from './components/landingpage-templates/template-list/template-list.component';
import { CaseStudyComponent } from './components/pages/case-study/case-study.component';
import { AuthGuard } from './components/auth/authguard ';

export const routes: Routes = [
  { path: '',component: HomeThreeComponent,
  },
  { path: 'login-register', component: LoginRegisterComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'coming-soon', component: ComingSoonComponent },
  { path: 'contact-us', component: ContactComponent },

  // Product Routes
  { path: 'medeil-cloud-pos', component: MedeilposComponent },
  { path: 'medeil-cloud-hq', component: MedeilhqComponent },
  { path: 'hosbay-healthcare', component: HosbayComponent },
  { path: 'medeil-pharmacy-software', component: MedeilstandaloneComponent },
  { path: 'allotmed-medical-supply', component: AllotmedComponent },
  { path: 'free-software-download', component: ProductloginComponent },

  // Pricing
  { path: 'allotmed-pricing', component: AllotmedpricingComponent },
  { path: 'medeil-hq-pricing', component: MedeilhqpricingComponent },
  { path: 'medeil-pos-pricing', component: MedeilpospricingComponent },
  { path: 'medeil-pricing', component: MedeilpricingComponent },

  // Verticals
  { path: 'industry/agriculture-software', component: GeneralagroComponent },
  { path: 'industry/beauty-software', component: GeneralcosmeticsComponent },
  { path: 'industry/medical-store-software', component: GeneralhealthcareComponent },
  { path: 'industry/optical-store-management', component: GeneralopticalsComponent },
  { path: 'industry/pharmacy-management-software', component: GeneralpharmacyComponent },
  { path: 'industry/veterinary-software', component: GeneralveterinaryComponent },
  { path: 'industry/surgical-equipment-software', component: SurgicaldeviceComponent },
  { path: 'industry/medical-device-software', component: MedeicaldeviceComponent },

  // Blog & Downloads
  { path: 'download-software', component: MedeildownloadComponent },
  { path: 'blogs', component: MedeilBlogsComponent },
  { path: 'view-blogs', component: ViewblogComponent, canActivate: [AuthGuard] },
  { path: 'blog/:slug', component: BlogDetailComponent },
  { path: 'wp-admin', component: AdminloginComponent },

  // Videos
{ path: 'view-videos', component: ViewVideosComponent, canActivate: [AuthGuard] },
  { path: 'add-video', component: AddVideosComponent },
  { path: 'more-details/:seoUrl', component: VideoDetailsComponent },
  { path: 'medeil-software-video', component: ProductVideoComponent },

  // Templates & Demo
  { path: 'medeil-cloud-pos-enquiry', component: PosenquiryComponent },
  { path: 'medeil-cloud-pos-demo', component: PosdemorequestComponent },
  { path: 'terms-condition', component: TermsConditionComponent },
  { path: 'landingpage-one/:seoUrl', component: TemplateOneComponent },
  { path: 'templates-two', component: TemplateTwoComponent },
  { path: 'templates-list', component: TemplateListComponent, canActivate: [AuthGuard] },

  // 404 Catch-All
  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
